import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import bus from '../lib/bus';
import { ref, onMounted, onBeforeMount, onBeforeUnmount, watch } from 'vue';
import { getSpaceKeyById } from '../lib/helper/useWap';
import { useStrategy } from '../lib/helper/useStrategy';
import { Haa } from '../lib/index';

export default /*#__PURE__*/_defineComponent({
  __name: 'wap-banner',
  props: {
    spaceKey: {}
  },
  emits: ['adclose', 'aderror', 'adclick'],
  setup(__props: any, { emit: emitAdStage }) {

const props = __props;


const { adId, spaceInfo, init, handleAdClose, handleAdError, handleAdClick, showYlhAd } = Haa.util().useWapHook(props.spaceKey);
const { strategy } = useStrategy();
// 刷新banner定时器
const timer = ref<any>();
const initAdScript = () => {
    if (spaceInfo.data) {
        if (spaceInfo.data.space_src == 'baidujs') {
            let wap = document.getElementById('wap-banner-' + adId);
            let script = document.createElement('script');
            script.src = spaceInfo.data.space_js;
            wap?.appendChild(script);

            if (strategy.banner_refresh_time && strategy.banner_refresh_time > 0 && !timer.value) {
                timer.value = setInterval(() => {
                    let child = wap?.childNodes;
                    if (child) {
                        for (let i = child.length - 1; i >= 0; i--) {
                            wap?.removeChild(child[i]);
                        }
                    }
                    // 上报广告请求等初始化打点
                    init();
                    // 重新加载脚本
                    initAdScript();
                }, strategy.banner_refresh_time * 1000);
            }
        } else {
            showYlhAd(spaceInfo.data.space_id, 'wap-banner-' + adId);
        }
    }
}
watch(
    () => spaceInfo.data,
    () => {
        initAdScript();
    }
)
onMounted(() => {
    initAdScript();
})


const handleClose = (params) => {
    let spaceKey = getSpaceKeyById(params.spaceId);
    if (spaceKey == props.spaceKey) {
        emitAdStage('adclose');
    }
    handleAdClose(params);
}
const handleError = (params) => {
    let spaceKey = getSpaceKeyById(params.spaceId);
    if (spaceKey == props.spaceKey) {
        emitAdStage('aderror');
    }
    handleAdError(params);
}
const handleClick = (params) => {
    let spaceKey = getSpaceKeyById(params.spaceId);
    if (spaceKey == props.spaceKey) {
        emitAdStage('adclick');
    }
    handleAdClick(params);
}
onBeforeMount(() => {
    bus.on('adclose', handleClose);
    bus.on('aderror', handleError);
    bus.on('adclick', handleClick);
});
onBeforeUnmount(() => {
    bus.off('adclose', handleClose);
    bus.off('aderror', handleError);
    bus.off('adclick', handleClick);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `wap-banner-${_unref(adId)}`,
    class: "wap-banner-wrapper"
  }, null, 8, _hoisted_1))
}
}

})